// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__GeBUn","header":"ClearentDisclaimer_header__2ah-3","inner":"ClearentDisclaimer_inner__1IzDX"};